"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEspoolAndChildren = void 0;
const Espool_1 = require("./Espool");
const isEspoolAndChildren = (whatever) => {
    const possibleEspoolAndChildren = whatever;
    return (possibleEspoolAndChildren === null || possibleEspoolAndChildren === void 0 ? void 0 : possibleEspoolAndChildren.espool) instanceof Espool_1.Espool && Array.isArray(possibleEspoolAndChildren === null || possibleEspoolAndChildren === void 0 ? void 0 : possibleEspoolAndChildren.children);
};
exports.isEspoolAndChildren = isEspoolAndChildren;
//# sourceMappingURL=EspoolAndChildren.js.map